module.exports = __webpack_public_path__ + "img/slider_galery_16.6a337653.jpg";